import React, { Component } from 'react'
import { BrowserRouter } from 'react-router-dom'
import AppContainer from './containers/App'
import './App.less'
import * as Sentry from "@sentry/react";
import { HttpClient, RewriteFrames } from "@sentry/integrations";
import CacheBuster from 'react-cache-buster'
export default class App extends Component {

  componentDidMount(): void {
    if (process.env.NODE_ENV !== 'development') {
      Sentry.init({
        // dsn: "https://cfb3af66d3325c7fd24cd0a00ee971c2@o4506220446220288.ingest.sentry.io/4506349126221824",
        dsn: "https://cfb3af66d3325c7fd24cd0a00ee971c2@o4506220446220288.ingest.us.sentry.io/4506349126221824",
        integrations: [new RewriteFrames(), new Sentry.BrowserTracing(), new HttpClient()],
        environment: process.env.REACT_APP_ENV_CODENAME,
        release: "legacy-web-admin@2.8.3",

        ignoreErrors: ['SyntaxError', 'Failed to fetch', /Failed to fetch/],
        // Performance Monitoring
        tracesSampleRate: 1, // Capture 100% of the transactions
      });

    }

  }

  render() {
    return (
      <CacheBuster
        currentVersion={'2.8.3'}
        isEnabled={true} //If false, the library is disabled.
        isVerboseMode={false} //If true, the library writes verbose logs to console.
        loadingComponent={<>Loading</>} //If not pass, nothing appears at the time of new version check.
        metaFileDirectory={'.'} //If public assets are hosted somewhere other than root on your server.
      >
        <BrowserRouter>
          <AppContainer />
        </BrowserRouter>
      </CacheBuster>
    )
  }
}
